import React from 'react';

import Fechamento from '../Fechamento';

const FechemantoPeriodo: React.FC = () => {
  return <Fechamento tipo="fechamentoperiodo" />;
};

export default FechemantoPeriodo;
